import { NavLink } from "react-router-dom";
import { BookOpen, Building2, Database, CheckSquare, CreditCard, LayoutDashboard, Mail, Plug, Radar, Settings, Target, Users } from "lucide-react";

export const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, id: "dashboard" },
  { to: "/research", label: "Research Campaigns", icon: Radar, id: "research", ai: true },
  { to: "/opportunities", label: "Opportunities", icon: Target, id: "opportunities" },
  { to: "/stage-1", label: "Stage 1 search", icon: Database, id: "stage1" },
  { to: "/companies", label: "Companies", icon: Building2, id: "companies" },
  { to: "/contacts", label: "Contacts", icon: Users, id: "contacts" },
  { to: "/email", label: "Email", icon: Mail, id: "email" },
  { to: "/tasks", label: "Tasks & Follow-ups", icon: CheckSquare, id: "tasks" },
  { to: "/knowledge", label: "Product Knowledge Base", icon: BookOpen, id: "knowledge" },
  { to: "/integrations", label: "Integrations", icon: Plug, id: "integrations" },
  { to: "/billing", label: "Billing", icon: CreditCard, id: "billing" },
  { to: "/settings", label: "Organisation Settings", icon: Settings, id: "settings" },
];

export function Sidebar({ onNavigate }) {
  return (
    <div className="flex h-full flex-col bg-[#080E21] text-slate-300">
      <div className="flex items-center gap-2.5 px-5 py-5">
        <div className="grid h-8 w-8 place-items-center rounded-lg bg-[#2EC4B6] font-display text-lg font-extrabold text-[#0B132B]">A</div>
        <div>
          <p className="font-display text-lg font-extrabold leading-none tracking-tight text-white">AJsource</p>
          <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-slate-500">Sales Intelligence</p>
        </div>
      </div>
      <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 py-2">
        {NAV.map(({ to, label, icon: Icon, id, ai }) => (
          <NavLink key={to} to={to} end={to === "/"} onClick={onNavigate} data-testid={`nav-${id}`}
            className={({ isActive }) => `group flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors ${isActive ? "bg-[#2EC4B6]/12 text-white shadow-[inset_2px_0_0_#2EC4B6]" : "hover:bg-white/5 hover:text-white"}`}>
            <Icon className="h-4 w-4 shrink-0 text-slate-400 group-hover:text-[#2EC4B6]" />
            <span className="flex-1 truncate">{label}</span>
            {ai && <span className="rounded bg-[#2EC4B6]/15 px-1.5 py-0.5 font-mono text-[9px] font-semibold text-[#2EC4B6]">AI</span>}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-white/5 px-5 py-4 text-[11px] text-slate-500">Phase 1 · Milestone 3</div>
    </div>
  );
}
